module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n  "), _c('a', {
    attrs: {
      "href": "https://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia - +55(47) 3635-1755")]), _vm._v(".")]), _vm._v(" Todos os direitos reservados.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a52a7b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 666
// module chunks = 1